<div class="participants">
    <ng-container *ngIf="participants?.items.length; else stub">
      <ng-container *ngFor="let participant of participants.items; trackBy: trackByFn">
        <app-classroom-participant-card
          [participant]="participant"
        ></app-classroom-participant-card>
      </ng-container>
    </ng-container>
</div>

<div class="invite">
  <span class="invite-link" (click)="openInviteModal()">Пригласить участников</span>
</div>

<ng-template #stub>
  <div class="stub">
    У вас нет учеников. <br> Пригласите учеников в класс оправив им приглашение
    <span class="invite-link" (click)="openInviteModal()">Оправить приглашение</span>
  </div>
</ng-template>

<app-modal *ngIf="inviteModal" [schedule]="true" [canClose]="false" (closed)="closeInviteModal()">
  <app-modal-body>
    <app-invite-to-classroom [classroom]="classroom"></app-invite-to-classroom>
  </app-modal-body>
</app-modal>
